import { NavigationControl } from 'maplibre-gl'

import { gettext } from '@bikemap/js/services'
import { setTooltip } from '@bikemap/js/utility'
import MapFeatureControl from './MapFeatureControl'

/**
 * Show zoom and bearing controls on the map.
 */
export default class ViewportControls extends MapFeatureControl {

    /** @type {NavigationControl} */
    _navigationControl

    /**
     * @param {Object} [settings]
     * @param {import('./MapFeatureControl').MapFeaturePosition} [settings.position]
     */
    constructor(settings = {}) {
        super()

        if (settings.position) {
            this.setPosition(settings.position)
        }

        this._navigationControl = new NavigationControl
    }

    _onAdd(map) {
        map.addControl(this._navigationControl, this.position)
        setTooltip('.maplibregl-ctrl-compass', gettext('Reset bearing to north'), this.tooltipPosition)
        setTooltip('.maplibregl-ctrl-zoom-out', gettext('Zoom out'), this.tooltipPosition)
        setTooltip('.maplibregl-ctrl-zoom-in', gettext('Zoom in'), this.tooltipPosition)
    }

    _onRemove(map) {
        map.removeControl(this._navigationControl)
    }

}
